module.exports = __webpack_public_path__ + "img/guide_music_btn1.5db24ee6.png";